import Logger from '@westwing/logger';

declare const window: Window;

interface Window {
    opera?: any;
    AndroidAppBridge: {
        postMessage: (json: string) => any;
    };
    webkit: {
        messageHandlers: {
            appBridge: {
                postMessage: (json: string) => any;
            };
        };
    };
}

const ANDROID_DEVICE = 'Android';
const IOS_DEVICE = 'iOS';

export default class AppBridge {
    private readonly deviceType: string;

    public static instance: AppBridge;

    private readonly logger: Logger;

    private constructor(logger: Logger) {
        this.logger = logger;
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;

        if (/android/i.test(userAgent)) {
            this.deviceType = ANDROID_DEVICE;
        } else if (/iPad|iPhone|iPod/.test(userAgent)) {
            this.deviceType = IOS_DEVICE;
        }
    }

    public static getInstance(logger: Logger): AppBridge {
        if (!this.instance) {
            this.instance = new this(logger);
        }

        return this.instance;
    }

    public sendTrackingData(data: any): void {
        this._postMessage('updateDataLayer', data);
    }

    private _postMessage(action: string, message: any): void {
        const payload = JSON.stringify({
            action,
            message,
        });

        try {
            if (this.deviceType === ANDROID_DEVICE) {
                window.AndroidAppBridge.postMessage(payload);
            }

            if (this.deviceType === IOS_DEVICE) {
                window.webkit.messageHandlers.appBridge.postMessage(payload);
            }
        } catch (e) {
            this.logger.error('Apps event triggering error', { error: e });
        }
    }
}
